if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();

      this.updateAvailability();
      this.addEventListener('change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(evt) {
      const selectedOptions = this.getSelectedOptions();
      this.variant = null;

      if (this.data && this.data.product && this.data.product.variants) {
        this.variant = this.data.product.variants.find((v) =>
          v.options.every((val, index) => val === selectedOptions[index])
        );
      }

      if (this.variant) {
        this.updateUrl(evt);
        this.updateVariantInput();

        const fetchUrl = `${this.dataset.url || window.location.pathname}?variant=${this.variant.id}`;

        fetch(fetchUrl)
          .then(response => response.text())
          .then(htmlStr => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlStr, 'text/html');

            document.querySelectorAll('[data-dynamic-variant-content]').forEach((toReplace) => {
              const key = toReplace.dataset.dynamicVariantContent;
              const replaceWith = doc.querySelector(`[data-dynamic-variant-content="${CSS.escape(key)}"]`);
              if (replaceWith) {
                toReplace.replaceWith(replaceWith);
              }
            });

            const customSelectors = [
              '#ttt-producthighlights',
              '#variant-description',
              '#variant-specifications',
              '#variant-lieferumfang'
            ];
            customSelectors.forEach(selector => {
              const currentEl = document.querySelector(selector);
              const newEl = doc.querySelector(selector);
              if (currentEl && newEl) {
                currentEl.innerHTML = newEl.innerHTML;
              }
            });

            this.updateSkuElementsLocal();
            this.updatePromotion();
            this.updateShippingCostInfo();

            document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true }));
          })
          .catch(err => console.error('Fehler beim Synchronisieren der Variantendaten:', err));
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice(); // <--- PREIS-UPDATE WIEDER AKTIV
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data ? this.data.product : null
        }
      }));
    }

    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant && this.data.formatted && this.data.formatted[this.variant.id]) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        if (priceCurrentEl) {
          priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        }
        
        if (priceWasEl) {
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
        }

        if (this.variant.unit_price_measurement && unitPriceEl) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          if (valueEl && unitEl) {
            const value = this.variant.unit_price_measurement.reference_value;
            const unit = this.variant.unit_price_measurement.reference_unit;
            valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
            unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          }
        }

        if (unitPriceEl) unitPriceEl.hidden = !this.variant.unit_price_measurement;
        
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      const defaultPrice = this.price.querySelector('.price__default');
      const noVariantPrice = this.price.querySelector('.price__no-variant');
      if (defaultPrice) defaultPrice.hidden = !this.variant;
      if (noVariantPrice) noVariantPrice.hidden = !!this.variant;
    }

    updateSkuElementsLocal() {
      if (!this.variant) return;
      const mobileSkuElement = document.getElementById('current-variant-sku');
      const desktopSkuElement = document.getElementById('desktop-current-variant-sku');

      if (mobileSkuElement) mobileSkuElement.textContent = this.variant.sku;
      if (desktopSkuElement) desktopSkuElement.textContent = this.variant.sku;
    }

    updatePromotion() {
      const promoBlock = document.querySelector('.js-promo-block');
      if (!promoBlock || !this.variant) return;

      const discountPercentage = parseFloat(promoBlock.dataset.discountPercentage);
      if (!discountPercentage) return;

      const variantPrice = this.variant.price / 100.0;
      const savings = (variantPrice * discountPercentage / 100.0).toFixed(2);
      
      const savingsElement = promoBlock.querySelector('.js-savings-amount');
      if (savingsElement) {
        savingsElement.textContent = savings;
      }
    }

    updateAddToCartButton() {
      if (!this.productForm) return;
      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      if (!this.addBtn) return;
      
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
    }

    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (!selector || selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      const valueEl = evt.target.nextElementSibling.querySelector('.js-value');
      colorText.textContent = valueEl ? valueEl.textContent : evt.target.value;
    }

    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    updateVariantInput() {
      this.forms = this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');
      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = this.variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    updateShippingCostInfo() {
      const shippingTextElement = document.querySelector('.shipping-cost-info-hx span');
      const iconElement = document.querySelector('.shipping-cost-info-hx .icon-shipcost');
      if (!shippingTextElement || !iconElement || !this.variant) return;

      const variantPrice = this.variant.price / 100;
      let shippingText = '';
      let activeClass = '';

      if (variantPrice < 49.99) {
        shippingText = 'zzgl. Porto-Option';
        activeClass = 'active-class-1';
      } else if (variantPrice < 98) {
        shippingText = 'inkl. Portoreduktion';
        activeClass = 'active-class-2';
      } else if (variantPrice < 300) {
        shippingText = 'inkl. Versand';
        activeClass = 'active-class-3';
      } else {
        shippingText = 'inkl. Priority Versand';
        activeClass = 'active-class-4';
      }

      shippingTextElement.textContent = shippingText;
      iconElement.className = 'icon-shipcost tooltip-trigger ' + activeClass;
    }

    getSelectedOptions() {
      const selectedOptions = [];
      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          const checkedInput = selector.querySelector('input:checked');
          selectedOptions.push(checkedInput ? checkedInput.value : '');
        }
      });
      return selectedOptions;
    }

    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      if (!dataEl) return null;
      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error("Fehler beim Parsen der Produktdaten:", e);
        return null;
      }
    }
  }

  customElements.define('variant-picker', VariantPicker);
}

if (!customElements.get('variant-picker-matrix')) {
  class VariantPickerMatrix extends HTMLElement {
    constructor() {
      super();
      this.variantPicker = document.querySelector('variant-picker');
      this.productComparison = document.querySelector('.product-comparison');
      
      if (this.variantPicker && this.productComparison) {
        this.variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    handleVariantChange(event) {
      const { variant, product } = event.detail;
      this.updateProductComparison(variant, product);
    }

    updateProductComparison(variant, product) {
      if (!variant || !this.productComparison) return;
      const closestSection = this.productComparison.closest('[data-section-id]');
      if (!closestSection) return;

      const url = `${window.location.pathname}?variant=${variant.id}&section_id=${closestSection.dataset.sectionId}`;
      
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const newProductComparison = parser.parseFromString(html, 'text/html').querySelector('.product-comparison');
          if (newProductComparison) {
            this.productComparison.innerHTML = newProductComparison.innerHTML;
          }
        })
        .catch(error => console.error('Fehler beim Aktualisieren des Produktvergleichs:', error));
    }
  }

  customElements.define('variant-picker-matrix', VariantPickerMatrix);
}

document.addEventListener('DOMContentLoaded', function() {
  if (!document.querySelector('variant-picker-matrix')) {
    const variantPickerMatrix = document.createElement('variant-picker-matrix');
    document.body.appendChild(variantPickerMatrix);
  }
});